<template>
    <ul class="mainmenu">
			  <li><router-link to="/">首頁</router-link></li>
			<li class="has-droupdown has-menu-child-item">
				<a href="#">
					AI產品
					<Icon name="plus" class="collapse-icon plus"/>
					<Icon name="minus" class="collapse-icon minus"/>
				</a>
				<ul class="submenu">
					<li><router-link to="/agent">企業級Agent中台</router-link></li>
					<li><router-link to="/deep-seek">DeepSeek企業版</router-link></li>
					<li><router-link to="/pc">PC本地部署大模型</router-link></li>
					<li><router-link to="/gen-ai">企業級一站式GenAI平台</router-link></li>
				</ul>
			</li>
        <li class="has-droupdown has-menu-child-item">
            <a href="#">
							數據產品
                <Icon name="plus" class="collapse-icon plus"/>
                <Icon name="minus" class="collapse-icon minus"/>
            </a>
            <ul class="submenu">
                <li><router-link to="/data-service1">數據安全管控平台</router-link></li>
                <li><router-link to="/data-service2">數據治理諮詢與實施服務</router-link></li>
                <li><router-link to="/data-service3">數字化應用開發</router-link></li>
            </ul>
        </li>
				<li><router-link to="/cloud-service">雲原生產品</router-link></li>
        <li><router-link to="/about">關於我們</router-link></li>
    </ul>
</template>

<script>
    import Icon from "../../icon/Icon";
		import {h} from "vue";
    export default {
        name: 'Nav',
        components: {Icon},
				data() {
						return {
							hoverId: 1
						}
				},
				methods: {
					h,
					onMouseEnter(idx){
						this.hoverId = idx;
					}
				}
    }
</script>
<style lang="scss" scoped>
	.subnav-container {
		&::before {
			content: '';
			width: 20%;
			height: 100%;
			background: -webkit-linear-gradient(to left, #94c6ff, transparent);
			background: linear-gradient(to left, #94c6ff, transparent);
			position: absolute;
			top: 0;
			left: 0;
		}
	}
	.subnav-left-box {
		float: left;
		width: 20%;
		text-align: left;
		padding-left: 5%;
		position: initial;
		ul {
			list-style: none outside none;
			padding: 0;
			margin: 0;
			padding-inline-start: 0;
		}
		li {
			font-size: 18px;
			line-height: 1.2;
			padding: 12px 0;
			a {
				display: block;
				color: #636363;
				font-size: 16px;
				cursor: pointer;
			}
			&.active a {
				font-weight: bold;
			}
		}
	}
	.subnav-right-box {
		padding: 0 10% 0 0;
		float: right;
		width: 80%;
		font-size: 16px;
		ul {
			display: flex;
			li {
				width: 50%;
				flex: 1;
				float: left;
				padding: 0 18px;
				font-size: 18px;
				line-height: 1.2;
				margin: 12px 0;

				.t-title {
					font-size: 16px;
					font-weight: bold;
					position: relative;
				}

				dl {
					margin-top: 20px;
					dd {
						margin-left: 0;
						margin-top: 16px;
						font-size: 16px;
					}
				}
			}
		}
	}
	.clearfix {
		display: block;
	}
	a {
		color: #65676b;
	}
</style>
